/**
 * 表の名前を、店の人が読める言葉にする。
 *
 * ★**監査トリガが張られている表を全部載せること。** 載っていない表は英語の識別子が
 *   そのまま画面に出る——F-22a の目的は「開発者に聞けば分かる状態を作らない」ことなので、
 *   1つでも欠けると、その表を触った瞬間に目的が崩れる
 *   （2026-08-20・spec-reviewer が差し戻し。29表のうち10表が欠けていた。
 *    ★開発DBにその表の記録がまだ無かったので、画面を見ても気づけなかった）。
 *
 * ★**`tests/ui/audit-table-label.test.ts` が `migrations/` から張られている表を数え上げ、
 *   ここに無い表があれば落とす。** 一覧を手で持つ限り、外側の出典と突き合わせないと必ず腐る。
 */
export const AUDIT_TABLE_LABEL: Record<string, string> = {
  daily_reports: "日報（振り返り）",
  daily_sales: "日次売上",
  daily_sales_targets: "日別の売上目標",
  monthly_targets: "月次目標",
  business_calendar: "営業日カレンダー",
  work_records: "勤務実績",
  work_punches: "打刻",
  punch_corrections: "打刻の訂正",
  shift_plans: "シフト（予定）",
  shift_requests: "希望シフトの申請",
  shift_plan_breaks: "シフト（予定）の休憩",
  expense_accounts: "固定費の科目",
  fixed_cost_monthly: "固定費の月額",
  documents: "証憑",
  document_upload_requests: "証憑画像の受付記録",
  document_revisions: "証憑の版",
  import_batches: "取込の記録",
  kintai_import_sessions: "kintai取込セッションの記憶",
  roles: "ロールの定義",
  purchases: "仕入",
  vendors: "仕入業者",
  petty_cash_entries: "小口現金",
  petty_cash_accounts: "小口現金の科目",
  cash_counts: "レジ金実査",
  inventories: "棚卸",
  loss_records: "ロス記録",
  staff: "従業員",
  staff_account_links: "従業員とアカウントの紐付け",
  staff_wages: "時給",
  staff_wage_bulk_exclusions: "一括改定の除外",
  parameter_values: "パラメータの値",
  parameter_definitions: "パラメータの定義",
  monthly_closings: "月次締め",
  integrity_check_results: "自動検算の結果",
  users: "ログインアカウント",
  user_store_roles: "権限",
  user_sessions: "ログインの記録",
  stores: "店舗",
};

/** ★載っていない表は識別子をそのまま返す。**隠すより、読めない名前でも出す** */
export const auditTableLabel = (name: string): string => AUDIT_TABLE_LABEL[name] ?? name;

/**
 * 操作の名前。
 *
 * ★**`audit_logs.action` の CHECK が許している値を全部載せること。** 載っていない操作は
 *   画面に `undefined` が出る（`AUDIT_ACTION_LABEL[action]` を直接埋め込んでいたため、
 *   2026-08-25 / B2f の時点で `LOGIN` / `EXPORT` / `APPROVE` / `REOPEN` の4つが
 *   その状態だった。**まだ誰も積んでいなかったので画面を見ても気づけない**）。
 *
 * ★`tests/ui/audit-action-label.test.ts` が `migrations/` の CHECK から値を数え上げ、
 *   ここに無い値があれば落とす。表の名前（上）と同じ理由で、一覧を手で持つ限り
 *   外側の出典と突き合わせないと必ず腐る。
 */
export const AUDIT_ACTION_LABEL: Record<string, string> = {
  INSERT: "追加",
  UPDATE: "変更",
  DELETE: "削除",
  LOGIN: "ログイン",
  EXPORT: "出力",
  APPROVE: "承認",
  REOPEN: "締め解除",
  PASSWORD_CHANGE_FAILED: "パスワード変更の失敗",
  LOGIN_FAILED: "ログインの失敗",
  LOGIN_BLOCKED: "ログイン試行の遮断",
};

/** ★載っていない操作は識別子をそのまま返す。**`undefined` を画面に出さない** */
export const auditActionLabel = (action: string): string => AUDIT_ACTION_LABEL[action] ?? action;
